import { Directive, inject, input, OnDestroy, OnInit } from '@angular/core';
import { FixedHeightService } from '../services';

@Directive({
    standalone: true,
})
export class FixedHeightDirective implements OnInit, OnDestroy {
    private readonly fixedHeightService = inject(FixedHeightService);

    readonly enabled = input(true);

    ngOnInit() {
        this.fixedHeightService.setFixedHeight(this.enabled());
    }

    ngOnDestroy() {
        this.fixedHeightService.setFixedHeight(false);
    }
}
